import React, { PropsWithChildren } from 'react'

interface Case {
  case: boolean
}
interface Default {
  default: boolean
}
export type ComponentSwitchCaseProps = PropsWithChildren<Case | Default>

export const ComponentSwitchCase: React.FC<ComponentSwitchCaseProps> = ({
  children,
}) => {
  return <>{children}</>
}
